// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Articles from "./Pages/Articles";
import ArticlePage from "./Pages/ArticlePage";
import PCAPAnalyzerArticle from "./Pages/PCAPAnalyzerArticlePage";
import LemurlootArticlePage from "./Pages/LemurlootArticlePage";
import SuricataBenchArticlePage from "./Pages/SuricataBenchArticlePage";
import EarthWormLabArticlePage from "./Pages/EarthWormLabArticlePage";
import EarthWormPygmyGoatArticlePage from "./Pages/EarthWormPygmyGoatArticlePage";
import JABenchAnyrunQuasarArticlePage from "./Pages/JABenchAnyrunQuasarArticlePage";
import GriftGithubSeoMalwareArticlePage from "./Pages/GriftGithubSeoMalwareArticlePage";
import Contact from "./Pages/Contact";
import NotFound from "./Pages/NotFound";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/automating-elevated-tasks" element={<ArticlePage />} />
          <Route path="/articles/pcap-analyzer" element={<PCAPAnalyzerArticle />} />
          <Route path="/articles/lemurloot" element={<LemurlootArticlePage />} />
          <Route path="/articles/suricata-bench" element={<SuricataBenchArticlePage />} />
          <Route path="/articles/earthworm-lab" element={<EarthWormLabArticlePage />} />
          <Route path="/articles/earthworm-pygmy-goat" element={<EarthWormPygmyGoatArticlePage />} />
          <Route path="/articles/ja-bench-anyrun-quasar" element={<JABenchAnyrunQuasarArticlePage />} />
          <Route path="/articles/grift-github-seo-malware" element={<GriftGithubSeoMalwareArticlePage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
